import React from "react";
import Reveal from "@/components/landing/Reveal";
import { TECH_CARDS } from "@/lib/landing-data";

/* -------------------------------------------------------------------------- */
/*  Sub-components                                                            */
/* -------------------------------------------------------------------------- */

const SectionHeading = () => (
    <div className="mx-auto max-w-3xl text-center">
        <Reveal>
            <p className="eyebrow inline-flex items-center justify-center gap-4">
                <span className="hairline" />
                Tecnologia &amp; Fluxo Digital
                <span className="hairline" />
            </p>
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className="mt-6 font-serif text-3xl font-medium leading-[1.1] text-onyx text-balance sm:text-4xl md:text-5xl lg:text-[52px]">
                Odontologia de{" "}
                <span className="italic text-navy">Alta Precisão</span>.
            </h2>
        </Reveal>
        <Reveal delay={0.2}>
            <p className="mx-auto mt-6 max-w-xl font-sans text-base font-light leading-relaxed text-onyx/65 md:text-[17px]">
                Um fluxo integrado, do diagnóstico à entrega. Cada etapa
                orquestrada por tecnologia de ponta e protocolos
                científicos.
            </p>
        </Reveal>
    </div>
);

const TechCard = ({ card, testId }) => (
    <article
        data-testid={testId}
        className="group relative flex h-full flex-col bg-ivory transition-all duration-500 hover:shadow-luxe"
    >
        <div className="relative aspect-[4/3] w-full overflow-hidden">
            <img
                src={card.image}
                alt={card.alt}
                loading="lazy"
                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-onyx/40 via-transparent to-transparent" />
        </div>

        <div className="flex flex-1 flex-col px-7 py-8 md:px-8 md:py-10">
            <h3 className="font-serif text-2xl font-medium leading-snug text-onyx md:text-[26px]">
                {card.title}
            </h3>
            <span
                aria-hidden="true"
                className="mt-4 inline-block h-px w-10 bg-gold-500 transition-all duration-500 group-hover:w-16"
            />
            <p className="mt-5 font-sans text-[15px] font-light leading-relaxed text-onyx/65 md:text-base">
                {card.body}
            </p>
        </div>
    </article>
);

const CardsGrid = () => (
    <div className="mt-20 grid grid-cols-1 gap-8 md:mt-24 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-8">
        {TECH_CARDS.map((card, i) => (
            <Reveal key={card.id} delay={0.1 + i * 0.1}>
                <TechCard card={card} testId={`tech-card-${i + 1}`} />
            </Reveal>
        ))}
    </div>
);

const PullQuote = () => (
    <Reveal delay={0.4}>
        <p className="mx-auto mt-16 max-w-2xl text-center font-sans text-sm font-light italic leading-relaxed text-onyx/55 md:mt-20">
            “A previsibilidade clínica nasce da união entre ciência,
            tecnologia e experiência cirúrgica.”
        </p>
    </Reveal>
);

/* -------------------------------------------------------------------------- */
/*  Technology                                                                */
/* -------------------------------------------------------------------------- */

const Technology = () => (
    <section
        id="tecnologia"
        data-testid="technology-section"
        className="relative bg-ash py-24 md:py-32 lg:py-40"
    >
        <div className="container-luxe">
            <SectionHeading />
            <CardsGrid />
            <PullQuote />
        </div>
    </section>
);

export default Technology;
